<template>
  <div class="client-testimonial">
    <div class="row">
      <div class="col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-5 client-testimonial__quote-column">
        <contentful-image
          :item="contentfulImage('homepage-2023-v01-testimonial-quote-image')"
          class="responsive-img"
        />
      </div>
    </div>
    <div class="client-testimonial__rating">
      <font-awesome-icon
        v-for="numStarIndex in testimonial.Rating"
        :icon="icons.faStar"
        :key="numStarIndex"
      />
    </div>
    <div class="client-testimonial__body">
      <vue-markdown :source="testimonial.Body" />
    </div>
    <div class="client-testimonial__person">
      <span class="client-testimonial__person-name">{{ testimonial.PersonName }},</span>
      {{ testimonial.PersonTitle }}
    </div>
    <div class="client-testimonial__client-info">
      <div class="row">
        <div class="col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4">
          <img
            v-if="testimonial.ClientLogo"
            :src="testimonial.ClientLogo.File.Url"
            :alt="testimonial.ClientLogo.Description"
            class="responsive-img"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import VueMarkdown from 'vue-markdown'

export default {
  name: 'ClientTestimonial',
  components: {
    VueMarkdown,
    FontAwesomeIcon
  },
  props: {
    testimonial: { type: Object, default: null, required: true }
  },
  data () {
    return {
      icons: {
        faStar
      }
    }
  },
  computed: {
    content () {
      return this.$store.state.pageContent
    }
  }
}
</script>

<style lang="scss" scoped>
.client-testimonial {
  border-radius: 20px;
  background-color: #f0f4f7;
  text-align: center;
  padding: 3rem 0;

  @media screen and (min-width: $screen-md-min) {
    padding: 4rem;
  }

  &__quote-column {
    padding: 0 1.4rem 1.4rem 1.4rem;
  }

  &__rating {
    color: #ffbf00;
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }

  &__body /deep/ p {
    color: #525252;
    font-family: $font-circular-std;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 1.5rem;
  }

  &__person {
    margin-bottom: 1rem;
    font-family: $font-circular-std;
    font-size: 1.2rem;

    &-name {
      font-size: 1.4rem;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentItems/ClientTestimonial.vue